import React, { useEffect } from 'react';
import Sidenavigation1 from '../../layouts/Sidenavigation1';

import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import Topnavigation from '../../layouts/Topnavigation';
import Restaurentcontent from './Restaurant-list/Restaurantcontent';


const Restaurantlist = (props) => {
    useEffect(() => {

        sessionStorage.setItem("pg", "pgBuisDetails")
    }, [])
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            <TheMasterContextProvider>
                <Sidenavigation1 />
                <main className="body-content">
                <Topnavigation />
                    <Restaurentcontent />
                </main>
                {/* <Quickbar /> */}
            </TheMasterContextProvider>
        </div>
    );
}

export default Restaurantlist;